import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import styles from './styles.css';

const MailingAddressDetails = ({ show, onHide, mailingAddress, mailingAddressError }) => (
  <Modal show={show} onHide={onHide}>
    <Modal.Header closeButton>
      <h2 className={styles['modal-title']}>
        Mailing Address
      </h2>
    </Modal.Header>
    <Modal.Body>
      {mailingAddress && !mailingAddressError &&
        <React.Fragment>
          {mailingAddress.addressLines.map((line) => (
            <div>{line}</div>
          ))}
        </React.Fragment>
      }
      {mailingAddressError && mailingAddressError.status === 403 &&
        <div>Permission denied on resource or it might not exist.</div>
      }
      {mailingAddressError && mailingAddressError.status !== 403 &&
        <div>There was an error loading this content. Please try again.</div>
      }
      <div className={styles.buttonWrapper}>
        <button onClick={onHide} className="buttons buttons-gray">
          Close
        </button>
      </div>
    </Modal.Body>
  </Modal>
);

MailingAddressDetails.propTypes = {
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  mailingAddress: PropTypes.object,
  mailingAddressError: PropTypes.object,
};

MailingAddressDetails.defaultProps = {
  mailingAddress: null,
  mailingAddressError: null,
};

export default MailingAddressDetails;



// WEBPACK FOOTER //
// ./src/components/ MailingAddressDetails/index.js